<template>
  <v-app class="left-bar-layout">
    <div class="max-height" style="display: flex;">
      <v-navigation-drawer
        v-model="drawer"
        absolute
        class="menu-background"
        temporary
      >
        <app-menu v-if="drawer"/>
      </v-navigation-drawer>
      <v-content>
        <v-container fluid pa-0 style="height: 100%">
          <v-layout justify-center fill-height>
            <v-flex md3 lg2 hidden-sm-and-down class="menu-background menu-min-width">
              <app-menu/>
            </v-flex>
            <v-flex md9 lg10 class="flex-col">
              <Navbar
                :name="name"
                :email="email"
                :admin="admin"
                @signout="signOut()"
                @toggle-drawer="drawer = !drawer"
                @new-transaction="newTransaction()"
              />
              <v-layout fill-height row wrap v-if="kind == 'two_columns'">
                <v-flex xs12 md6>
                  <slot name="left">
                    <h1 class="max">bye bye bank fees, hello world<span class="font-blue">.</span></h1>
                    <h4 class="mt-5 hidden-sm-and-down">send money abroad quickly — straight to your friends’ and family’s bank accounts. the rate is always great. the fee is always low.</h4>
                    <div class="sm-and-down" style="height: 20px; width: 100%"></div>
                  </slot>
                </v-flex>
                <v-flex xs12 md6>
                  <slot></slot>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="kind == 'one_column'">
                <v-flex xs12 class="flex-col">
                  <slot></slot>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </div>
      <NewTransactionDialog
        v-if="admin==false"
        :dialog="dialogNewTransaction"
        @close-dialog="dialogNewTransaction = false"
      />
    <NewUserDialog
      :dialog="dialogNewUser"
      :user="userToEdit"
      :company="company_id"
      @close-dialog="dialogNewUser = false"
    />
  </v-app>
</template>
<script>
import AppMenu from "../Menu"
import Navbar from '../components/Navbar'
import NewTransactionDialog from '../components/NewTransactionDialog'
import NewUserDialog from '../components/NewUserDialog'

export default {
  name: 'LeftBarLayout',
  components: {
    'app-menu': AppMenu,
    Navbar,
    NewTransactionDialog,
    NewUserDialog
  },
  props: {
    kind: {
      type: String,
      default: 'two_columns'
    }
  },
  data() {
    return {
      drawer: null,
      signedIn: false,
      name: '',
      email: '',
      admin: undefined,
      dialogNewTransaction: false,
      dialogNewUser: false,
      userToEdit: null,
      company_id: null
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    isSelected(path) {
      return this.$route.path == path
    },
    signOut() {
      this.$cookies.remove('api_token')
      this.$cookies.remove('email')
      this.$cookies.remove('name')
      this.signedIn = false
      this.$router.push('/')
    },
    logoClick() {
      if (this.signedIn) {
        this.$router.push('/dashboard')
      } else {
        this.$router.push('/')
      }
    },
    newTransaction() {
      this.dialogNewTransaction = true
    }
  },
  mounted() {

    this.$nextTick(function () {
      this.signedIn = this.$cookies.isKey('api_token') && this.$cookies.get('api_token') !== ''
      this.name = this.$cookies.get('name')
      this.email = this.$cookies.get('email')
      this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
    })
    this.$root.$on('openNewUserForm', (company) => {
      this.userToEdit = null
      this.company_id = company
      this.dialogNewTransaction = false
      this.dialogNewUser = true
    })
    this.$root.$on('openEditUserForm', (user, company) => {
      this.userToEdit = user
      this.company_id = company
      this.dialogNewTransaction = false
      this.dialogNewUser = true
    })
    this.$root.$on('userUpdated', (updated_user) => {
      if (this.userToEdit && this.userToEdit.id == updated_user.id) {
        this.userToEdit = updated_user
      }
    })
  }
}
</script>
<style>
  @import url("https://use.typekit.net/gbx5lto.css");
  .left-bar-layout {
    font-family: 'Paralucent';
  }

  .color-logo-green {
    color: var(--logo-green);
  }
  .color-dark-blue {
    color: var(--dark-blue);
  }
  .color-light-red {
    color: var(--light-red-color);
  }
  .nowrap {
    white-space: nowrap!important;
  }
  .uppercase {
    text-transform: uppercase!important;
  }

  .light-regular-font,
  .light-regular-font .theme--light.v-table td{
    font-family: 'Paralucent' !important;
    color: #858EA1 !important;
  }
  .light-regular-font,
  .light-regular-font .theme--light.v-table th{
    font-family: 'Paralucent' !important;
    color: #44517B !important;
  }

  .application.left-bar-layout {
    background-color: #F7F7FC !important;
    color: #44517B !important;
  }

  .v-text-field--box .v-input__slot {
    border-bottom-left-radius: 2px;
    border-top-right-radius: 0px;
  }

  .border-radius-10 {
    border-radius: 10px!important;
  }

  .app-navigation { height: 60px; background-color: var(--navigation-color); }
  .app-footer-disabled { position: absolute; left: 0px; bottom: -20px;}


  /* https://cssgradient.io/ */
  .menu-background {
    background: #06233B !important;
    padding-top: 20px;
  }
  .menu-background .theme--dark.v-list {
    background: transparent;
  }
  .menu-background .v-list--dense .v-list__tile {
    font-size: 14px!important;
    margin-left: 12px;
    color: #858EA1;
  }
  .menu-min-width {
    width: 260px!important;
  }
  .menu-active,
  .menu-active:hover {
    background-color: #0C2E4A !important;
    color: white!important;
  }

  .menu-active.v-list__tile {
    padding-left: 10px!important;
  }
  .v-list__group__items--no-action .menu-active.v-list__tile {
    padding-left: 66px!important;
  }

  .border-radius-10 {
    border-radius: 10px!important;
  }

  body { padding: 0px; margin: 0px; }

  body,
  div.max-height { height: 100%!important; position: relative!important; }

  .max-width-1200 { max-width: 1200px!important; }

  .left-bar-layout h1.max {
    font-family: 'Paralucent';
    font-weight: 500;
    font-size: 24px !important;
    line-height: 22px;
    color: #0C2E4A;
  }
  .font-blue { color: var(--text-dot-color)!important }

  h4 { font-weight: 300!important; }

  .btn-style, .btn-style--secondary, .btn-style--tertiary, .btn-style--gray {
    height: 56px!important;
  }
  .btn-style.small, .btn-style--secondary.small, .btn-style--tertiary.small, .btn-style--gray.small {
    height: 20px!important;
  }
  .btn-style.medium, .btn-style--secondary.medium, .btn-style--tertiary.medium, .btn-style--gray.medium {
    height: 30px!important;
  }
  .btn-style {
    background-color: var(--primary-button-background-color)!important;
  }
  .btn-style--secondary {
    background-color: var(--secondary-button-background-color)!important;
  }
  .btn-style--tertiary {
    background-color: var(--tertiary-button-background-color)!important;
  }
  .btn-style--gray {
    background-color: var(--dark-blue)!important;
    color: var(--silver-color-font-color)!important;
  }

  .card-title-text {
    flex: 1;
    display: flex;
    justify-content: center;
    color: var(--background-color);
  }

  .input-control-with-grow > .v-input__control {
    flex-grow: 1;
  }

  .theme--light.v-text-field--box>.v-input__control>.v-input__slot {
    background-color: transparent!important;
  }

  /* v-autocomplete changes to match the appearence of other fields */
  .v-autocomplete.v-input>.v-input__control>.v-input__slot {
    padding: 0 12px!important;
  }

  .v-input.v-text-field.v-autocomplete {
    margin: 0px;
    padding: 0px;
  }
  .v-input.v-text-field.v-autocomplete input {
    margin-top: 22px!important;
  }
  .v-text-field.v-autocomplete>.v-input__control>.v-input__slot {
    align-items: stretch!important;
    min-height: 56px!important;
  }
  .v-text-field.v-autocomplete .v-text-field__details {
    margin-bottom: 8px!important;
  }
  .v-text-field.v-autocomplete .v-label {
    top: 18px!important;
  }
  .v-text-field.v-autocomplete .v-label--active {
    transform: translateY(-6px) scale(.75);
  }
  .v-text-field.v-autocomplete .v-input__append-inner {
    align-self: center;
  }
  .v-text-field.v-autocomplete>.v-input__control>.v-input__slot:before {
    border-width: thin 0!important;
  }
  .left-bar-layout .toolbar-btn {
    color: var(--background-color)!important;
  }

  /*Animations*/

  .fade-enter-active {
    transition: all .9s ease;
  }
  .fade-leave-active {
    transition: all .0s ease;
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-leave-to {
    opacity: 0;
  }
  .arrow-icon-small {
    height: 14px!important;
    margin: 0px!important;
    padding: 0px!important;
    width: 12px!important;
    font-size: 14px!important;
  }
  .v-list__tile__action, .v-list__tile__avatar {
    min-width: 38px;
  }
  input:focus.no-input-focus {
    outline: none;
  }

  .top-submenu a.v-list__tile {
    text-align: center!important;
  }

  table.v-table tbody td:first-child,
  table.v-table tbody td:not(:first-child) {
    padding: 0 4px!important;
    white-space: nowrap!important;
  }
  table.v-table thead th:first-child,
  table.v-table thead th:not(:first-child) {
    padding: 0 4px!important;
  }

  .black-select, .black-autocomplete {
    background-color: #0C2E4A!important;
    border-radius: 4px!important;
    border: 1px solid rgba(142, 174, 198, 0.2)!important;
  }

  .black-autocomplete .v-select__slot {
    margin-top: -5px!important;
    padding-bottom: 10px!important;
  }
  .black-autocomplete .v-input__slot {
    margin-top: -5px!important;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-bottom: -20px!important;
  }

  .white-select {
    border-bottom: 2px solid rgba(145, 145, 145, 1)!important;
  }

  .black-select, .white-select {
    padding: 14px 8px 4px 8px!important;
    margin-bottom: 0px!important;
    margin-top: 0px!important;
  }

  .white-select .v-input__control,
  .black-select .v-input__control  {
    height: 37px!important;
  }
  .white-select .v-input__slot::before,
  .black-select .v-input__slot::before {
    border-color: transparent!important;
  }

  .transactions-filter {
    background-color: white;
    border-radius: 6px;
    align-items: center;
  }
  .transactions-filter .v-text-field .v-input__slot {
    border: 1px solid #F7F7FC !important;
  }
  .transactions-filter .v-select__selection {
    color: #44517B;
  }
  .transactions-filter .v-text-field .v-text-field__slot input {
    color: #44517B;
  }
  .transactions-filter .operation-radio-group {
    margin-top: 0;
    padding-top: 0;
  }
  .transactions-filter .filter-btn {
    border-radius: 4px;
    height: 56px;
    margin-bottom: 32px;
  }
  .transactions-filter .filter-btn ion-icon {
    position: relative;
    right: -8px;
  }
  .transactions-filter .reload-filter-btn {
    border-radius: 4px;
    height: 56px;
    width: 56px;
    margin-bottom: 32px;
    background-color: #BCC1D1;
  }
  .align-contents-right {
    display: flex;
    justify-content: flex-end;
  }
  .align-contents-center {
    display: flex;
    justify-content: center;
  }
  .rounded-chip {
    background-image: linear-gradient(0deg, var(--secondary-button-background-color), var(--secondary-button-background-color), rgba(135,199,201,1));
    border-radius: 10px;
    padding: 3px 10px 3px 10px;
    color: white;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/LeftBarLayout.vue